import {Component} from '@angular/core';
import {AuthService} from './services/auth.service';

@Component({
  selector: 'aw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'iotcy';

  constructor(private authService: AuthService) {
  }

}
